import { getLicenses, readLicenses } from "./queries";
import typeDefs from "./typeDefs";
import useLicenses, { useLicense } from "./hooks";
import * as queryResolvers from "./resolvers";

export { getLicenses, useLicenses, useLicense, readLicenses };
export default { typeDefs, queryResolvers };
